import { Component } from '@angular/core';
import * as $ from 'jquery';
import lazySizes from 'lazysizes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  ngOnInit() {

    Object.assign(lazySizes.cfg, {
      // your config goes here
    })

    var NavInit = new NavManagement()
    var CookieInit = new CookieManagement()

    NavInit.Nav()
    CookieInit.CookieInit()
    CookieInit.CookieLang()
  }
}

export class NavManagement extends AppComponent{
  
  public Nav(){
    $(document).ready(function (){

      //mobile nav
      $('.hamburger, .mobile-menu a').click(
        function(){
          $('.hamburger').toggleClass('is-active')
          $('.mobile-menu').toggleClass('mobile-open')

          if($('.hamburger').is('.is-active')){
            $('html, body').css({'overflow-y' : 'hidden'})
          } else {
            $('html, body').css({'overflow-y' : 'visible'})
          }
        })

        //on scroll
        $(window).scroll(function(){
          if ($(document).scrollTop() > 45){
           $('.menu').addClass('lock')
           $('.logo-small').addClass('logo-small-visible')

          } else {
            $('.menu').removeClass('lock')
            $('.logo-small').removeClass('logo-small-visible')
          }
        })

        //to top
        $(".totop").click(function () {
          $('html, body').animate({scrollTop: 0}, 500);
        })

        //truncate text
        $('.truncate').each(function(index, value) {
          $(this).html($(this).html().substring(0, 200));
        })
    })
  }
}

export class CookieManagement extends AppComponent{
  public CookieInit(){
    $(document).ready(function() {

      var cookievalue :string = 'cookiepolicy=consented'

      if(document.cookie === cookievalue){
        $('.cookie').css({'display' : 'none'})
      } else {
        $('.cookie').css({'display' : 'block'})
      }

      $('.cookie-compliance').click(function(){
        document.cookie = cookievalue
        $('.cookie').css({'display' : 'none'})
      })
    })
  }

  public CookieLang(){
    $(document).ready(function() {

      var ita = 'Questo sito utilizza i cookie per migliorare la tua esprienza di navigazione. <a href="./cookie" target="_blank">Approfondisci</a>';
      var btn_ita = 'Ho capito';

      $('.cookietext').html(ita);
      $('.cookie-compliance').html(btn_ita);
    })
  }

  public CookieLangHider(){
    $(document).ready(function() {
      $('.cookie').add('footer').add('.products-footer-content').add('#navigation').css({'display': 'none', 'visibility': 'hidden'});
      $('.html, body').css({'background': '#f3f3f3'});
    })
  }
}